import styled from 'styled-components';

export const StyledH1 = styled.h1`
  font-size: 40px;
  font-weight: 700;
  line-height: 46.88px;
  text-align: left;
  margin-block-end: 2.5rem;
`;

export const StyledStrong = styled.strong`
  font-size: 16px;
  font-weight: 700;
  line-height: 26px;
  text-align: left;
`;

export const StyledParagraph = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  text-align: left;
  margin-block-end: 2.5rem;
`;

export const StyledUlParagraph = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  text-align: left;
`;

export const StyledStrongParagraph = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  text-align: left;
`;

export const StyledUl = styled.ul`
  padding-left: 30px;
`;
